// Redstone-component per-state glow (MB.1). PURE (ENG-1). A lit redstone lamp /
// torch / ore / copper bulb emits light; the unlit state emits none. The world
// builds its emissionByState from this so the light engine propagates a
// component's on/off glow (the directional wall-mount *mesh* is a separate render
// remainder).
import { oxidationStageOf } from './copper';

/** A lit copper bulb's light dims as it oxidizes (Java: 15 → 12 → 8 → 4). */
export const COPPER_BULB_EMISSION = [15, 12, 8, 4] as const;

/** Light a block state emits, given its name, resolved props, and the block's
 *  static default emission. Lit redstone components glow; everything else keeps
 *  its static value. */
export function stateEmission(name: string, props: Readonly<Record<string, string>>, defEmission: number): number {
  const lit = props.lit === 'true';
  // Copper bulbs (any oxidation/wax prefix): lit emission dims with oxidation.
  if (name.endsWith('copper_bulb')) {
    const stage = oxidationStageOf(name);
    return lit && stage >= 0 ? COPPER_BULB_EMISSION[stage] ?? 0 : 0;
  }
  switch (name) {
    case 'redstone_lamp': return lit ? 15 : 0;
    case 'redstone_torch':
    case 'redstone_wall_torch': return lit ? 7 : 0;
    case 'redstone_ore':
    case 'deepslate_redstone_ore': return lit ? 9 : 0;
    default: return defEmission;
  }
}
